import './style.scss'
import dayjs from 'dayjs';
import { useState, useEffect, useRef } from 'react';
import { Button, DatePicker, Modal, Tooltip, InputNumber} from 'antd'

import utc from 'dayjs/plugin/utc'; // Import UTC plugin for dayjs
import timezone from 'dayjs/plugin/timezone'; // Import timezone plugin for dayjs
import { Switch } from 'antd';
dayjs.extend(utc); // Enable the UTC plugin
dayjs.extend(timezone); // Enable the timezone plugin
import 'dayjs/locale/en'; // Import the locale you want to use
import { isTimeIntervalValid, handleDownload } from './DownloadWidget';
import { useIsSuperAdmin ,useIsAdmin, useMobileStore, } from '../../store';

import {HourglassOutlined, DownloadOutlined } from '@ant-design/icons';

function Archive({disableDate, disableTime, periscopeStreamID, lowresStreamID}) {
    const isMobile = useMobileStore((state) => state.isMobile);
    
    const controllerRef = useRef(new AbortController())
    const [modalOpen, setModalOpen] = useState(false)
    const [timelapseMode, setTimelapseMode] = useState(false)
    const [archiveStartTime, setArchiveStartTime] = useState(dayjs().subtract(2, 'minutes').unix())
    const [archiveEndTime, setArchiveEndTime] = useState(dayjs().unix())
    const [targetTime, setTargetTime] = useState(5)
    const isSuperAdmin = useIsSuperAdmin();
    const [useLowRes, setUseLowRes] = useState(false)

    useEffect(() => {
        controllerRef.current = new AbortController()

        return () => {
            controllerRef.current.abort()
        }
    }, [])


const handleSetArchiveStartTime = (e) => {
  const value = e.target.value; // "YYYY-MM-DDTHH:mm:ss"
  if (value) {
    setArchiveStartTime(dayjs(value).unix());
  }
};

const handleSetArchiveEndTime = (e) => {
    const value = e.target.value
    if (value) {
        setArchiveEndTime(dayjs(value).unix())
    }
}

// Convert unix timestamp back to input format for defaultValue
const defaultValue = dayjs().subtract(2, 'minutes').format('YYYY-MM-DDTHH:mm:ss');

// For min/max constraints (replaces disabledDate/disabledTime)
const minValue = dayjs().subtract(7, 'days').format('YYYY-MM-DDTHH:mm:ss');
const maxValue = dayjs().format('YYYY-MM-DDTHH:mm:ss');

return (
    <>
        <Tooltip
            title="Download"
            placement='left'
        >
            <Button
                className='video-header-button'
                ghost
                onClick={(e) => {
                    e.stopPropagation()
                    setTimelapseMode(false)
                    setModalOpen(!modalOpen)
                    }
                }
            >
            {<DownloadOutlined/>}
            </Button>
        </Tooltip>

        {isSuperAdmin && 
            <Tooltip
                title="Timelapse"
                placement='left'
            >

                <Button
                    className='video-header-button'
                    ghost
                    onClick={(e) => {
                        e.stopPropagation()
                        setTimelapseMode(true)
                        setModalOpen(!modalOpen)
                        }
                    }
                >
                <HourglassOutlined/>
                </Button>
            </Tooltip>
        }
        
        <Modal
            title={timelapseMode ? 'Download Timelapse' : 'Download Archives'}
            centered
            open={modalOpen}
            onCancel={() => {
                setModalOpen(false)
            }
            }
            onOk={() => {
                setModalOpen(false)
                
                handleDownload(
                    periscopeStreamID,
                    lowresStreamID,
                    archiveStartTime,
                    archiveEndTime,
                    timelapseMode,
                    targetTime,
                    useLowRes
                )
            }}
            className='download-modal-container'
            okText='Download'
            cancelText='Cancel'
            okButtonProps={{
                disabled: !isTimeIntervalValid(archiveStartTime, archiveEndTime) && !timelapseMode
            }}
            style={{
                maxHeight: '100vh'
            }}
        >
            <div className='download-modal-container'>
                <div>From</div>

                {!isMobile ? (
                    <DatePicker
                        showTime={{ format: 'HH:mm:ss' }}
                        onChange={(value, timeString) => {
                            setArchiveStartTime(dayjs(timeString, 'MM-DD-YYYY HH:mm:ss').unix())
                        }}
                        format={'MM/DD/YYYY HH:mm:ss'}
                        defaultValue={dayjs().subtract(2, 'minutes')}
                        disabledDate={disableDate}
                        disabledTime={disableTime}
                    /> 
                    ):(
                    <input
                        type="datetime-local"
                        defaultValue={defaultValue}
                        min={minValue}
                        max={maxValue}
                        step="1" // enables seconds
                        onChange={handleSetArchiveStartTime}
                        style={{ /* optional: match your app's styling */
                            padding: '8px',
                            borderRadius: '6px',
                            border: '1px solid #d9d9d9',
                            fontSize: '16px', // IMPORTANT: prevents iOS auto-zoom on focus
                        }}
                    />
                )}

                <div>To</div>

                {!isMobile ? (
                    <DatePicker
                        showTime={{ format: 'HH:mm:ss' }}
                        onChange={(value, timeString) => {
                            setArchiveEndTime(dayjs(timeString, 'MM-DD-YYYY HH:mm:ss').unix())
                        }}
                        format={'MM/DD/YYYY HH:mm:ss'}
                        defaultValue={dayjs()}
                        disabledDate={disableDate}
                        disabledTime={disableTime}
                    />
                    ) : (
                    <input
                        type="datetime-local"
                        defaultValue={maxValue}
                        min={minValue}
                        max={maxValue}
                        step="1" // enables seconds
                        onChange={handleSetArchiveEndTime}
                        style={{ /* optional: match your app's styling */
                            padding: '8px',
                            borderRadius: '6px',
                            border: '1px solid #d9d9d9',
                            fontSize: '16px', // IMPORTANT: prevents iOS auto-zoom on focus
                        }}
                    />
                )}

                {timelapseMode && 
                    <div>Target Length (Minutes)</div>
                }

                {timelapseMode && (
                    isMobile ? (
                        
                        <input
                            type="number"
                            min={1}
                            step={1}
                            defaultValue={5}
                            onChange={(e) => setTargetTime(parseInt(e.target.value, 10))}
                        />
                    ) : (
                        <InputNumber
                            //style={{ width: 120 }}
                            //size="small"
                            min={1}
                            max={60}
                            step={1}
                            precision={0}
                            defaultValue={5}
                            onChange={(value) => setTargetTime(value)}
                        />
                    )
                )}

                {timelapseMode && (
                    <>
                    <div>Resolution (Minutes)</div>

                    <Switch
                        checked={useLowRes}
                        onChange={(checked) => setUseLowRes(checked)}
                        checkedChildren="Low"
                        unCheckedChildren="High"
                    />
                    </>
                )}

                {!timelapseMode && !isTimeIntervalValid(archiveStartTime, archiveEndTime) && (
                    <div style={{ color: '#ff4d4f', marginTop: '12px', fontSize: '14px' }}>
                        ⚠️ Time interval must not exceed 5 minutes
                    </div>
                )}
            </div>
        </Modal>
        
    </>
)
}

export default Archive